import { Channel } from '@nemuru-eng/js-api-client';

import { ChannelCredentialsTabs } from '@/components/modules/Users/components/ChannelCredentialsTabs';
import { SubSectionWrapper } from '@/components/shared/components/SubSectionWrapper';
import { ModuleCorePermissionProps } from '@/config/types';

interface ChannelUsersProps extends ModuleCorePermissionProps {
  selectedChannel: Channel | undefined;
}
export const ChannelUsers = ({ canEdit, selectedChannel }: ChannelUsersProps) => {
  if (!selectedChannel) return null;

  return (
    <SubSectionWrapper title={'USERS_OF'} dynamicDataTexts={[selectedChannel.description]}>
      <ChannelCredentialsTabs canEdit={canEdit} selectedChannel={selectedChannel} />
    </SubSectionWrapper>
  );
};
